import { Button, FormControl, InputGroup, ListGroup, Container, Row, Col } from "react-bootstrap";
import { useEffect, useState, useContext} from "react";
import deleteIcon from "../../../assets/delete.png";
import editIcon from "../../../assets/editing.png";
import Icon from "../../generic/Icon";
import ModalConfirmation from "../../modal_confirmacion";
// jquery
import $ from "jquery";

import GenericTable from "../../generic/GenericTable";
import { AgregarExterno } from "./AgregarExterno";
import { ModalContext } from "../../../context/modalContext";
import { putExtern, postExtern } from "../../../services/usuario/usuario";

// Buscador y lista de los externos de cada organizacion
const ListaExternos = ({ fetchExternos, urlAdd, familia }) => {
    const [externos, setExternos] = useState([]);
    const [searchValue, setSearchValue] = useState("");

    const [mostrarModal, setMostrarModal] = useState();
    const [aBorrar, setABorrar] = useState();

    const fn = async () => {
        setExternos(await fetchExternos(null, searchValue ? searchValue : null));
    };

    //102022
    // Contexto para modal de formularios
    const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);

    useEffect(() => {
        fn()
    }
        , [fetchExternos, searchValue])

    const manejaModal = (id) => {
        setMostrarModal(!mostrarModal)
        setABorrar(id)
    }

    const deleteExterno = (id) => {
        // Elimina un cargo a la entidad

        let settings = {
            url: `${process.env.REACT_APP_API_URL}/externos/${id}`,
            method: "DELETE",
            xhrFields: {
                withCredentials: true,
            },
        };
        $.ajax(settings)
            .done((response) => {
                fn()
                setABorrar()
            })
            .fail((error) => {

            });
    }

    return (
        <>
            <InputGroup className={"py-2"}>
                <FormControl type="text" placeholder="Buscar externos" value={searchValue}
                    onChange={e => setSearchValue(e.target.value)} />
                <Button variant="outline-primary" id="button-addon2" className={"ml-1"} onClick={() => {
                                        modalSetShow(true, "80%");
                                        modalSetTitle(`Añadir responsable externo`);
                                        modalSetContent(<AgregarExterno 
                                            familiaURL={familia === 'FET' ? '/familia/fet' : familia === 'FUNDEO' ? '/familia/fundeo' : '/familia/mta"'} 
                                            name={familia === 'FET' ? "Fundación Escuela Teresiana" : familia === 'FUNDEO' ? 'Fundación Enrique Osso' : 'Movimiento Teresiano Apostólico'} 
                                            logo={familia === 'FET' ? "logoFET.png" : familia === 'FUNDEO' ? 'logoFUNDEO.png' : 'logoMTA.png'} 
                                            familia={familia} 
                                            apaga={modalSetShow}
                                            recarga={fn}
                                            post={postExtern}/>
                                        );
                                    }}>
                    Añadir responsable externo
                </Button>
            </InputGroup>

            <Container>
                <GenericTable>
                    <thead>
                        <th>Nombre</th>
                        <th>Apellido 1</th>
                        <th>Apellido 2</th>
                        <th>email</th>
                        <th title="Editar nombre, apellidos o email de personal">Editar</th>
                        <th title="Eliminar personal externo puede dejar sin referencia a los cargos de responsabilidad asociados al mismo">Eliminar</th>

                    </thead>

                    <tbody>
                        {externos.map(e =>
                            <tr >
                                <td className="col-3">{e.name}</td>
                                <td className="col-2">{e.firstSurname}</td>
                                <td className="col-2">{e.secondSurname ? e.secondSurname : ""}</td>
                                <td className="col-4">{e.email ? e.email : ""}</td>
                                <td className="col-1" title="Editar nombre, apellidos o email de personal"><Icon
                                    src={editIcon}
                                    onClick={() => {
                                        modalSetShow(true, "80%");
                                        modalSetTitle(`Editar datos de responsable externo`);
                                        modalSetContent(<AgregarExterno 
                                            familiaURL={familia === 'FET' ? '/familia/fet' : familia === 'FUNDEO' ? '/familia/fundeo' : '/familia/mta"'} 
                                            name={familia === 'FET' ? "Fundación Escuela Teresiana" : familia === 'FUNDEO' ? 'Fundación Enrique Osso' : 'Movimiento Teresiano Apostólico'} 
                                            logo={familia === 'FET' ? "logoFET.png" : familia === 'FUNDEO' ? 'logoFUNDEO.png' : 'logoMTA.png'} 
                                            familia={familia} 
                                            edit={e} 
                                            put={putExtern}
                                            apaga={modalSetShow}
                                            recarga={fn}/>
                                        );
                                    }}
                                    className="d-flex m-auto"
                                /></td>
                                <td className="col-1" title="Eliminar personal externo puede dejar sin referencia a los cargos de responsabilidad asociados al mismo"><Icon
                                    src={deleteIcon}
                                    onClick={() => manejaModal(e.id)}
                                    className="d-flex m-auto"
                                /></td>
                            </tr>
                        )}
                    </tbody>

                </GenericTable>
                <ModalConfirmation
                    texto={"¿Está seguro de que quiere eliminarlo? No podrá deshacer esta acción"}
                    show={mostrarModal}
                    handleButtonShow={manejaModal}
                    deleteFunction={() => deleteExterno(aBorrar)}
                />

                <Row className="mt-2">AVISO: Eliminar personal externo puede dejar sin referencia a los cargos de responsabilidad asociados al mismo</Row>
            </Container>
        </>
    )
};

export default ListaExternos;